import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { borderRadius, space } from '@synoptic/ui-kit/tokens.ts';
import { style } from '@vanilla-extract/css';

export const previewPostCardContainer = style({
  border: `1px solid ${themeVars.container.border.default}`,
  borderRadius: borderRadius.r16,
  padding: space.s20,
});

export const previewPostCardContainerWithHover = style({
  ':hover': {
    backgroundColor: themeVars.container.primary.background.hover,
  },
});
